import { PartnerTeamView } from "@/components/partner/PartnerViews";

const PartnerTeam = () => <PartnerTeamView />;

export default PartnerTeam;
